import { mount } from 'svelte';
import CentreAide from './centre-aide/CentreAide.svelte';

mount(CentreAide, {
  target: document.getElementById('centre-aide')!,
});
